export default __webpack_public_path__ + "static/media/26.0ca39a91.png";